import {createStore, Store} from 'redux';
import {appReducer} from './reducers';
import {AppStore} from './types';

export const initializeStore = (): Store<AppStore> => createStore(appReducer);
